import { CSSProperties } from 'react';

export enum WhoOptions {
    NONE = '',
    INSURANCE = 'Insurance',
    CONSULTING = 'Consulting',
    RECRUITMENT = 'Recruitment',
    MARINE_ENERGY = 'MarineEnergyInsurance',
    CAPTIVE = 'CaptiveInsurance',
    PROPERTY_CASUALTY = 'PropertyCasualtyInsurance',
    OTHER = 'Other',
}
export interface ContactFormData {
    firstName: string;
    lastName: string;
    email: string;
    message: string;
    who: WhoOptions;
}

export interface ContactProps {
    extraStyles?: CSSProperties;
}
